import React from "react";
import Header from "../components/Header";
import {link} from "react-router-dom";
import TallyEmbed from "../components/TallyEmbed";
import { Helmet } from "react-helmet-async";

function GetInTouch() {
  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/journey", label: "Our Journey" },
    { to: "/blog", label: "Blogs & Insights" },
    { to: "/get-in-touch", label: "Support" },

    // { to: "/chat", label: "Meet Sparky" }
  ];

  return (
    <>
    <Header links={navLinks} />

    <Helmet>
      {/* Title and Meta Description */}
      <title>Get in Touch | DataPulse AI</title>
      <meta name="title" content="Get in Touch | DataPulse AI" />
      <meta name="description" content="Ready to automate, streamline, or just curious? Contact DataPulse AI to explore how we can help your business grow smarter with automation and AI." />
      <link rel="canonical" href="https://www.mydatapulse.co.uk/get-in-touch" />

      {/* Open Graph */}
      <meta property="og:site_name" content="DataPulse AI" />
      <meta property="og:title" content="Get in Touch | DataPulse AI" />
      <meta property="og:description" content="Ready to automate, streamline, or just curious? Contact DataPulse AI to explore how we can help your business grow smarter with automation and AI." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.mydatapulse.co.uk/get-in-touch" />
      <meta property="og:image" content="https://www.mydatapulse.co.uk/website_landing_image.jpg" />
      <meta property="og:image:alt" content="Contact DataPulse AI Page View" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Get in Touch | DataPulse AI" />
      <meta name="twitter:description" content="Ready to automate, streamline, or just curious? Contact DataPulse AI to explore how we can help your business grow smarter with automation and AI." />
      <meta name="twitter:image" content="https://www.mydatapulse.co.uk/website_landing_image.jpg" />
      <meta name="twitter:image:alt" content="Contact DataPulse AI Page View" />

      {/* Robots */}
      <meta name="robots" content="index, follow" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Get in Touch | DataPulse AI",
          "url": "https://www.mydatapulse.co.uk/get-in-touch",
          "description": "Contact DataPulse AI to explore automation and AI solutions for your business.",
          "publisher": {
            "@type": "Organization",
            "name": "DataPulse AI",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.mydatapulse.co.uk/logo-clean-large.png"
            }
          }
        })}
      </script>
    </Helmet>

    <body>

      <section class="bg-white dark:bg-gray-900">
        <div className="max-w-screen-xl px-4 pt-20 pb-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:pt-28">
          <div className="mx-auto place-self-center">
            <div class="max-w-screen-sm mx-auto text-center">
                <h2 class="mb-10 text-3xl pb-8 font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">Automate, Optimize, and Grow with DataPulse!</h2>
                <span class="font-light text-gray-500 dark:text-gray-400 md:text-lg">Book a <text class="text-title-purple">FREE Discovery call</text> to explore how automation can transform your company!</span><br/>

                <div class="p-6 mt-2">
                  <a
                    href="https://api.whatsapp.com/send/?phone=447447164108&text=Hi%20DataPulse%20AI%20%F0%9F%91%8B%20I%27d%20love%20to%20learn%20more%20about%20what%20you%20can%20do!&type=phone_number&app_absent=0"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-semibold rounded-lg text-xl px-5 py-3 focus:outline-none"
                  >
                    <img
                      src="/assets/images/whatsapp.svg"
                      alt="WhatsApp"
                      className="w-6 h-6 mr-2"
                    />
                    Get in touch on WhatsApp now!
                  </a>

                </div>
                <div class="p-4">
                  <text class="mt-2 text-xl text-gray-400 font-bold">- or add your details here -</text>
                </div>


                </div>

            <TallyEmbed/>
          </div>
        </div>
      </section>
    </body>

    </>
  );
}

export default GetInTouch;
